function getCartSectionsToRender() {
  const sections = new Set(['cart-icon-bubble']);

  if (document.querySelector('cart-drawer')) {
    sections.add('cart-drawer');
  }

  const mainCartItems = document.getElementById('main-cart-items');
  if (mainCartItems && mainCartItems.dataset.id) {
    sections.add(mainCartItems.dataset.id);
  }

  const mainCartFooter = document.getElementById('main-cart-footer');
  if (mainCartFooter && mainCartFooter.dataset.id) {
    sections.add(mainCartFooter.dataset.id);
  }

  if (document.getElementById('cart-live-region-text')) {
    sections.add('cart-live-region-text');
  }

  return Array.from(sections);
}

function buildCartUpdatePayload(rewardId) {
  return {
    attributes: { _roadmap_loyalty_reward_id: rewardId },
    sections: getCartSectionsToRender(),
    sections_url: window.location.pathname,
    updates: window.RoadmapData?.Cart?.items || [],
  };
}

function init(selector = '.select-point-redemption-method') {
  const dropdowns = document.querySelectorAll(selector);

  for (const dropdown of dropdowns) {
    const dropdownTrigger = dropdown.querySelector(
      '.select-point-redemption-method__trigger',
    );
    const dropdownContent = dropdown.querySelector(
      '.select-point-redemption-method__dropdown',
    );
    const dropdownOptions = dropdown.querySelectorAll(
      '.select-point-redemption-method__option',
    );
    const message = dropdown.querySelector(
      '.select-point-redemption-method_message',
    );

    // Check if event listener already exists
    if (!dropdownTrigger.hasAttribute('data-listener-added')) {
      dropdownTrigger.addEventListener('click', function (e) {
        // If a reward is applied (container has 'selected'), clicking removes it instead of toggling the dropdown
        if (dropdown.classList.contains('selected')) {
          e.preventDefault();
          // Optimistic UI reset
          dropdown.classList.remove('selected');
          const p = dropdownTrigger.querySelector('p');
          if (p) {
            p.textContent = 'NONE';
            p.classList.remove('selected');
          }
          dropdownTrigger.classList.remove('active');
          dropdownContent.classList.remove('active');
          dropdownOptions.forEach((o) => {
            o.classList.remove('selected');
            if (o.dataset.value === '') o.classList.add('selected');
          });

          // API call to clear cart attribute with loader
          try {
            fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(buildCartUpdatePayload('')),
              mode: 'cors',
              credentials: 'include',
            })
              .then(response => response.json())
          .then(cartContent => {
                // Dispatch cart:change event to trigger cart updates throughout the theme
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'point-redemption:update',
                cart: cartContent
              }
            }));

            window.dispatchEvent(new CustomEvent('roadmap:cart:update', {
              detail: {
                source: 'select-point-redemption-method',
                cartData: cartContent,
              },
            }));
              });
          } catch (err) {
            console.error(err);
          }
          return; // Do not proceed to open dropdown
        }
        // Normal behaviour: toggle dropdown visibility
        dropdownTrigger.classList.toggle('active');
        dropdownContent.classList.toggle('active');
      });
      dropdownTrigger.setAttribute('data-listener-added', 'true');
    }

    dropdownOptions.forEach((option) => {
      // Check if event listener already exists
      if (!option.hasAttribute('data-listener-added')) {
        option.addEventListener('click', function () {
          // Check if option is disabled
          if (option.dataset.disabled === '1') {
            // Just close the dropdown if disabled
            dropdownTrigger.classList.remove('active');
            dropdownContent.classList.remove('active');
            return;
          }

          const selectedValue = option.dataset.value;
          dropdownTrigger.querySelector('p').textContent = option.dataset.text;
          dropdownTrigger.querySelector('p').classList.add('selected');
          dropdownOptions.forEach((option) => {
            option.classList.remove('selected');
          });
          option.classList.add('selected');
          dropdownTrigger.classList.remove('active');
          dropdownContent.classList.remove('active');

          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(buildCartUpdatePayload(selectedValue)),
            mode: 'cors',
            credentials: 'include',
          })
            .then(response => response.json())
          .then(cartContent => {
              // Dispatch cart:change event to trigger cart updates throughout the theme
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'point-redemption:update',
                cart: cartContent
              }
            }));

            window.dispatchEvent(new CustomEvent('roadmap:cart:update', {
              detail: {
                source: 'select-point-redemption-method',
                cartData: cartContent,
              },
            }));
            });
        });
        option.setAttribute('data-listener-added', 'true');
      }
    });
  }
}
window.initSelectPointRedemptionMethod = init;

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    window.initSelectPointRedemptionMethod();
  }, 1000);
});